import service from "../util/http";
// 索赔列表
export const claimantList = (data) => {
    return service({
      url: "/customer/kdClaim/queryPageList",
      method: "post",
      data,
    });
};

// 新建/编辑索赔单
export const submitClaimant = (data) => {
    return service({
      url: "/customer/kdClaim/insertOrUpdate",
      method: "post",
      data,
    });
};

// 撤回索赔单 
export const revokeClaimant = (data) => {
  return service({
    url: "/customer/kdClaim/revoke",
    method: "post",
    data,
  });
};
// 取消索赔单
export const cancelClaimant = (data) => {
  return service({
    url: "/customer/kdClaim/cancel",
    method: "post",
    data,
  });
};
// 提交索赔单 
export const toSubmitClaimant = (data) => {
  return service({
    url: "/customer/kdClaim/submit",
    method: "post",
    data,
  });
};
// 历史记录
export const auditHistoryList = (data) => {
  return service({
    url: "/customer/kdClaim/newAuditHistoryList",
    method: "post",
    data,
  });
};
// 导出索赔单
export const exportClaim = (data) => {
  return service({
    url: "/customer/kdClaim/export",
    method: "post",
    responseType: "blob",
    data,
  });
};

// 导出索赔单
export const settlementExport = (data) => {
  return service({
    url: "/customer/claim/settlementExport",
    method: "post",
    responseType: "blob",
    data,
  });
};
// 获取账号国家
export const getUserInfo = (data) => {
  return service({
    url: "/customer/kdClaim/accountNumber",
    method: "post",
    data,
  });
};
// 根据code获取字典
export const getPreset = (data) => {
  return service({
    url: "/customer/kdClaim/getPreset",
    method: "post",
    data,
  });
};